import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { BillingOrdenControlWizardService } from '../../../services/billing/billing-orden-control-wizard.service';
import { BillingOrderControlService } from '../../../services/billing/billing-order-control.service';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { WizardStep } from '../../../wizard/wizard.component';
import { BillingOrdenControlPatientComponent } from '../billing-orden-control-patient/billing-orden-control-patient.component';
import { BillingOrdenControlValorizationComponent } from '../billing-orden-control-valorization/billing-orden-control-valorization.component';
import { BillingOrdenControlMedicalOrderComponent } from '../billing-orden-control-medical-order/billing-orden-control-medical-order.component';
import { ResizedEvent } from 'angular-resize-event';
import { StudyReportRegionView } from '../../../model/study-report/study-report-region-view';
import { SafeResourceUrl } from '@angular/platform-browser';
import { BillingOrdenControlGeneralComponent } from '../billing-orden-control-general/billing-orden-control-general.component';
import { MenuService } from '../../../services/menu.service';
import { BillingOrdenControlProcedureAffectedDialogComponent } from '../../dialogs/billing-orden-control-procedure-affected-dialog/billing-orden-control-procedure-affected-dialog.component';
import { MedicalAppointmentProcedure } from '../../../model/medical-appointment-procedure';
import { NoBillingReasonDialogComponent, NoBillingReasonDialogResponse } from '../../dialogs/no-billing-reason-dialog/no-billing-reason-dialog.component';
import { BillingOrdenControlScannComponent } from '../billing-orden-control-scann/billing-orden-control-scann.component';
import { LogViewDialogComponent } from '../../dialogs/log-view/log-view-dialog.component';
import { PdfService } from 'src/app/services/pdf.service';
import { InvoicePatientCashDeskService } from '../../../services/invoice-cash-desk/invoice-patient-cash-desk.service';
import { AuthService } from '../../../services/auth.service';
import { InvoiceManualCashDeskService } from '../../../services/invoice-cash-desk/invoice-manual-cash-desk.service';
import { BillingOrdenControlInvoiceComponent } from '../billing-orden-control-invoice/billing-orden-control-invoice.component';

@Component({
  selector: 'app-billing-orden-control-wizard',
  templateUrl: './billing-orden-control-wizard.component.html',
  styleUrls: ['./billing-orden-control-wizard.component.css'],
  providers: [BillingOrdenControlWizardService, InvoiceManualCashDeskService]
})
export class BillingOrdenControlWizardComponent implements OnInit {

  @ViewChild('tabGroup', {static: false}) tabGroup: MatTabGroup;
  canViewControlOrdenAttachedFile: boolean;
  loadingAction: boolean;
  medicalOrderId: number;
  medicalAppointmentId: number;
  protocol: string;
  loading: boolean;
  readOnly: boolean;
  noControlStateId: number;
  controlStateId: number;
  partialControlStateId: number;
  noBillStateId: number;
  widthExp: number;
  loadingReport: boolean;
  studyReportRegionViews: StudyReportRegionView[] = [];
  safeResourceUrl: SafeResourceUrl;
  studyReportRegionView: StudyReportRegionView;
  cashDeskSafeResourceUrl: SafeResourceUrl;
  invoiceId?: number;
  invoiceManualId?: number;
  index = 0;

  @ViewChild('billingOrdenControlPatient', {static: false}) billingOrdenControlPatient: BillingOrdenControlPatientComponent;
  @ViewChild('billingOrdenControlValorization', {static: false}) billingOrdenControlValorization: BillingOrdenControlValorizationComponent;
  @ViewChild('billingOrdenControlMedicalOrder', {static: false}) billingOrdenControlMedicalOrder: BillingOrdenControlMedicalOrderComponent;
  @ViewChild('billingOrdenControlScann', {static: false}) billingOrdenControlScann: BillingOrdenControlScannComponent;
  @ViewChild('billingOrdenControlGeneral', {static: false}) billingOrdenControlGeneral: BillingOrdenControlGeneralComponent;
  @ViewChild('billingOrdenControlInvoice', {static: false}) billingOrdenControlInvoice: BillingOrdenControlInvoiceComponent;



  constructor(private route: ActivatedRoute,
    private authService: AuthService,
    private notificationToastService: NotificationToastService,
    private billingOrderControlService: BillingOrderControlService,
    private menuService: MenuService,
    private dialog: MatDialog,
    private invoiceCashDeskService: InvoicePatientCashDeskService,
    private invoiceManualCashDeskService: InvoiceManualCashDeskService,
    private pdfService: PdfService,
    private billingOrdenControlWizardService: BillingOrdenControlWizardService) { }

  ngOnInit() {

    this.authService.canViewControlOrdenAttachedFile()
    .then(value =>  this.canViewControlOrdenAttachedFile  = value );

    this.route.params.subscribe(async (params) => {
      try {
        this.loading = true;
        this.medicalAppointmentId = params['MedicalApponitmentId'];
        this.protocol = params['Protocol'];
        this.medicalOrderId = params['MedicalOrderId'];
        const billingOrderControl = await this.billingOrderControlService
                                        .getBillingOrderControl(this.medicalAppointmentId);



        this.invoiceId = billingOrderControl.InvoiceId;
        this.invoiceManualId  = billingOrderControl.InvoiceManualId;
        this.noControlStateId = billingOrderControl.NoControlStateId;
        this.controlStateId = billingOrderControl.ControlStateId;
        this.partialControlStateId = billingOrderControl.PartialControlStateId;
        this.noBillStateId = billingOrderControl.NoBillStateId;



        this.billingOrdenControlWizardService.setBillingOrderControl(billingOrderControl);
        this.menuService.setMenuTitle('Control órden  ', '  ' + this.protocol);
        this.loadReports();
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Control órden');
      } finally {
        this.loading = false;
      }
    });
  }

  private loadReports() {
    this.billingOrdenControlWizardService.getStudyReportRegionViews().then((info) => {
      this.studyReportRegionViews = info;
      if (this.studyReportRegionViews.length > 0) {
        this.studyReportRegionView = this.studyReportRegionViews[0];
        this.studyReportRegionViewChange();
      }
    });

    if ( this.invoiceId ) {
     this.invoiceCashDeskService.getInvoiceCashDeskPdf( this.invoiceId ).then( (invoiceCashDesk) => {
      const pdfUrl = this.pdfService.base64ToPdfUrl(invoiceCashDesk.ReportBase64);
      this.cashDeskSafeResourceUrl = this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl);
     } );
    }

    if ( this.invoiceManualId ) {
      this.invoiceManualCashDeskService.getInvoiceCashDeskPdf( this.invoiceManualId ).then( (invoiceCashDesk) => {
       const pdfUrl = this.pdfService.base64ToPdfUrl(invoiceCashDesk.ReportBase64);
       this.cashDeskSafeResourceUrl = this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl);
      } );
    }

  }

  getInvoiceSafeResourceUrl() {
    return this.cashDeskSafeResourceUrl;
  }

  studyReportRegionViewChange() {
    this.billingOrdenControlWizardService
    .getStudyReport(this.studyReportRegionView.StudyReportId).then((safeReport) => {
      this.safeResourceUrl = safeReport;
     });
  }

  getSafeResourceUrl(): SafeResourceUrl {
    return this.safeResourceUrl;
  }

  selectedIndexChange(newIndex: number) {
    this.validateSteps(newIndex, true);
    const steps = this.getSteps();
    if (steps.length > newIndex) {
      steps[newIndex].activate();
    }
  }

  private validateSteps(newIndex: number, validateComplete: boolean = false): boolean {

    const steps = this.getSteps();
    let inx = 0;
    let hasError = false;
    while (inx <= newIndex && steps.length > inx && !hasError) {
      hasError = validateComplete? !steps[inx].completed : !steps[inx].valid;
      inx = inx + 1;
    }

    if (hasError) {
      this.tabGroup.selectedIndex = inx - 1;
    }

    return hasError;
  }

  private getSteps() {
    const steps: WizardStep[] = [];


    if (this.billingOrdenControlGeneral
      && this.billingOrdenControlGeneral.isInit) {
      steps.push(this.billingOrdenControlGeneral);
    }

    if (this.billingOrdenControlPatient
      && this.billingOrdenControlPatient.isInit) {
      steps.push(this.billingOrdenControlPatient);
    }

    if (this.billingOrdenControlValorization
      && this.billingOrdenControlValorization.isInit) {
      steps.push(this.billingOrdenControlValorization);
    }

    if (this.billingOrdenControlInvoice) {
      steps.push(this.billingOrdenControlInvoice);
    }

    if (this.billingOrdenControlScann
      && this.billingOrdenControlScann.isInit) {
      steps.push(this.billingOrdenControlScann);
    }

    if (this.billingOrdenControlMedicalOrder
      && this.billingOrdenControlMedicalOrder.isInit) {
      steps.push(this.billingOrdenControlMedicalOrder);
    }

    return steps;
  }

  openAdmisionLogViewDialog(): void {
    this.dialog.open(LogViewDialogComponent, {
      width: '50%',
      data: this.medicalAppointmentId
    });
  }

  async save(billingStateId?: number, noBillingReasonId?: number, observation: string = '') {
    try {

      if (!this.validateSteps(this.getSteps().length - 1)) {

        const procedures = (await this.billingOrdenControlWizardService.getBillingValorization())
          .ValorizationEdit.ValorizationAmount.ValorizationItemsAmount
          .filter(v => v.ValorizationItem.MedicalAppointmentProcedure.Quantity  > 0)
          .map(v => v.ValorizationItem.MedicalAppointmentProcedure);
          procedures.forEach(p => p.ChangeBillingState = true);

          if (billingStateId && procedures.length > 1) {
            this.showProcedureAffectedDialogForSave(procedures, billingStateId, noBillingReasonId, observation);
          } else {
            this.finalizeSave(billingStateId, noBillingReasonId, observation);
          }
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Control órden');
    } finally {
      this.loadingAction = false;
    }
  }

  async finalizeSave(billingStateId?: number, noBillingReasonId?: number, observation: string = '') {
    this.loadingAction = true;
    await this.billingOrdenControlWizardService.save(billingStateId, noBillingReasonId, observation);
    history.back();
  }

  async rollBackOrderControlState() {
    this.loadingAction = true;
    await this.billingOrdenControlWizardService.rollBackOrderControlState();
    history.back();
  }

  async finalizeRollBackOrderControlState() {
    try {
      if (!this.validateSteps(this.getSteps().length - 1)) {

        const procedures = (await this.billingOrdenControlWizardService.getBillingValorization())
          .ValorizationEdit.ValorizationAmount.ValorizationItemsAmount
          .filter(v => v.ValorizationItem.MedicalAppointmentProcedure.Quantity  > 0)
          .map(v => v.ValorizationItem.MedicalAppointmentProcedure);
          procedures.forEach(p => p.ChangeBillingState = true);

          if (procedures.length > 1) {
            this.showProcedureAffectedDialogForRollBack(procedures);
          } else {
           this.rollBackOrderControlState();
          }
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Control órden');
    } finally {
      this.loadingAction = false;
    }
  }

  private showProcedureAffectedDialogForSave(
    procedures: MedicalAppointmentProcedure[], billingStateId: number,
    noBillingReasonId?: number, observation: string = '') {
    const dialogRef = this.showProcedureAffectedDialog(procedures);
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.finalizeSave(billingStateId, noBillingReasonId, observation);
      }
    });
  }

  private showProcedureAffectedDialogForRollBack(procedures: MedicalAppointmentProcedure[]) {
    const dialogRef = this.showProcedureAffectedDialog(procedures);
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        this.rollBackOrderControlState();
      }
    });
  }

  private showProcedureAffectedDialog(procedures: MedicalAppointmentProcedure[]) {
    return this.dialog.open(BillingOrdenControlProcedureAffectedDialogComponent, {
      width: '500px',
      data: procedures
    });
  }

  showNoBillingReasonDialog() {
    if (!this.validateSteps(this.getSteps().length - 1)) {
      const dialogRef = this.dialog.open(NoBillingReasonDialogComponent, {
        width: '50%',
        data: { }
      });

      dialogRef.afterClosed().subscribe((response: NoBillingReasonDialogResponse) => {
        if (response) {
           this.save(this.noBillStateId, response.noBillingReason.Id, response.observations);
        }
      });
    }
  }

  cancel() {
    history.back();
  }

  onResized(event: ResizedEvent): void {
    this.widthExp = event.newWidth;
  }
}
